import { lazy, Suspense } from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';

// Lightweight pages: imported directly (small bundle impact)
import HomePage from '@/pages/HomePage';
import RankingsDefinitionsPage from '@/pages/RankingsDefinitionsPage';
import TransparencyDefinitionsPage from '@/pages/TransparencyDefinitionsPage';
import RankingsHowToUsePage from '@/pages/RankingsHowToUsePage';
import TransparencyHowToUsePage from '@/pages/TransparencyHowToUsePage';
import AppPrivacyPage from '@/pages/AppPrivacyPage';
import NotFoundPage from '@/pages/NotFoundPage';

// Heavy pages: lazy-loaded so their chunks (table libs, CSV parser) only download when needed
const RankingsPage = lazy(() => import('@/pages/RankingsPage'));
const TransparencyPage = lazy(() => import('@/pages/TransparencyPage'));
const GhgShopperPage = lazy(() => import('@/pages/GhgShopperPage'));

// Reserve enough vertical space during lazy-load to prevent large CLS when the
// table/grid content replaces the fallback.
function TableLoading() {
  return (
    <div className="container-md" style={{ paddingTop: '2rem', minHeight: '80vh' }}>
      Loading…
    </div>
  );
}

const router = createBrowserRouter([
  { path: '/', element: <HomePage /> },
  { path: '/rankings', element: <Navigate to="/rankings/2021" replace /> },
  { path: '/rankings/:year', element: <Suspense fallback={<TableLoading />}><RankingsPage /></Suspense> },
  { path: '/transparency', element: <Navigate to="/transparency/2021" replace /> },
  { path: '/transparency/:year', element: <Suspense fallback={<TableLoading />}><TransparencyPage /></Suspense> },
  { path: '/ghgshopper', element: <Suspense fallback={<TableLoading />}><GhgShopperPage /></Suspense> },
  { path: '/rankings-definitions', element: <RankingsDefinitionsPage /> },
  { path: '/transparency-definitions', element: <TransparencyDefinitionsPage /> },
  { path: '/rankings-how-to-use', element: <RankingsHowToUsePage /> },
  { path: '/transparency-how-to-use', element: <TransparencyHowToUsePage /> },
  { path: '/app-privacy', element: <AppPrivacyPage /> },
  { path: '*', element: <NotFoundPage /> },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
